export const getFileNameFromContentDisposition = (contentDisposition: string | null, fallbackFileName: string) => {
    if (!contentDisposition) {
        return fallbackFileName;
    }

    const utf8FileNameMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8FileNameMatch && utf8FileNameMatch[1]) {
        return decodeURIComponent(utf8FileNameMatch[1]);
    }

    const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
    if (fileNameMatch && fileNameMatch[1]) {
        return fileNameMatch[1];
    }

    return fallbackFileName;
};

export const downloadBlobFile = (blob: Blob, fileName: string) => {
    const downloadUrl = window.URL.createObjectURL(blob);

    try {
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } finally {
        window.URL.revokeObjectURL(downloadUrl);
    }
};
